import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import preload from 'api/data-preload';
import seoPreload, { seoDecorator } from 'api/seo';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import { SeoText } from 'components/layouts';
import Container from 'components/container';
import Breadcrumbs from 'components/breadcrumbs';

import linksBildControl from 'src-sites/bildcontrol/links';

import ContactsBlock from './blocks/block-contacts';
import WriteUsBlock from '../blocks/block-write-us';

import translates from './contacts-i18n.json';

import 'styles/bildcontrol/section-contacts/_page-contacts.scss';

const classes = new Bem('pageContacts');

@preload({
  ...seoPreload({ entity: 'pageContacts' }, [])
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@mstatDecorator(marketStatEvents.historyChange, () => ({ entity: 'Контакты' }))
@I18nHoc(translates)
export default class PageContacts extends Component {
  static propTypes = {
    className: PropTypes.string,
    location: PropTypes.shape({}),
    seoData: PropTypes.shape({}),
  };

  render() {
    const { i18n } = this;
    const { className, location, seoData } = this.props;
    const seoLocation = get(location, 'pathname');
    const seoText = get(seoData, 'bottomText');
    const header = get(seoData, 'header') ? seoData.header : i18n('contactsH1');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksBildControl.sectionBildControl,
        builderProps: { title: i18n('breadcrumbsMain') }
      }, {
        name: header,
        builder: linksBildControl.sectionContacts
      }
    ];

    return (
      <div {...classes({ extra: className })}>
        <ContactsBlock {...classes('blockContacts')} topic={header} />
        <WriteUsBlock {...classes('blockWriteUs')} url={seoLocation} />
        <Container body>
          <Breadcrumbs {...classes('breadcrumbs')} data={dataBreadcrumbs} />
          <SeoText data={seoText} />
        </Container>
      </div>
    );
  }
}
